import React, { Component } from 'react'
import { withNamespaces } from 'react-i18next'
import './listing_relax.scss'

class ListingRelax extends Component {
  render() {
    const { t } = this.props
    return (
      <React.Fragment>
        <div styleName="relax">
          <div styleName="dark-layer">
            <div styleName="relax-contents">
              <h3 styleName="relax-heading">{t('vietnam.relax')}</h3>
              <a styleName="relax-button" href={this.props.link}>
                <span styleName="relax-button-label">{t('vietnam.experience')}</span>
              </a>
            </div>
          </div>
        </div>

        {this.props.children}

        <div styleName="diamonds-division">
          <img styleName="diamonds-image" src="/assets/image/country/vietnam/diamonds.svg" alt="" />
        </div>
      </React.Fragment>
    )
  }
}
export default withNamespaces('vietnam')(ListingRelax)
